/* eslint import/prefer-default-export: off */
import { v } from './vars';

export const isDesktop = () => (
  v('deviceInfo').deviceType === 'desktop'
);
